<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      CreditPoliciesPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'CreditPoliciesPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'CreditPolicies', title: this.$t('Views.CreditPoliciesPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
